// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// index.js
// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import loadEvents from "./event";
// import applyColorClasses from "./applyColorClasses";
import initializeFeaturedCarousel from "./featuredCarousel";

// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();

// Load event cards
loadEvents();

// Apply color classes
// applyColorClasses();

// Initialize the featured carousel
document.addEventListener("DOMContentLoaded", () => {
    initializeFeaturedCarousel();
});
